import { Controller } from "@hotwired/stimulus"

// Sibling of backtest-form; receives rendered HTML via the
// backtest-form#backtest-results outlet.
export default class extends Controller {
  replace(html) {
    this.element.innerHTML = html
  }
}
